<template>
  <b-modal
    content-class="mymodalContent"
    modal-class="mymodal"
    id="deleteElement"
    centered
    hide-header
    hide-footer
  >
    <div class="modal-div">
      <h2>{{ title }}</h2>

      <p v-html="message" class="message"></p>

      <div class="popin-actions">
        <b-button class="popin-btn-cancel" @click="$bvModal.hide('deleteElement')">
          <cancel-icon title />
          {{ cancelButton }}
        </b-button>
        <b-button
          class="refonte_btn-primary popin-btn-confirm"
          @click="processAction()"
        >
          <check-icon title />
          {{ sendButton }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import CheckIcon from "vue-material-design-icons/Check.vue";

export default {
  name: "PopinDeleteElement",
  components: {
    CancelIcon,
    CheckIcon
  },
  computed: {
    params: function() {
      return this.$store.state.appState.popinParams;
    }
  },
  watch: {
    params: function() {
      const i18nPrefixes = {
        "DEL-DESCRIPTION_SITUATION_ELEMENT":
          "components.popinDeleteElement.description",
        "DEL-OBJECTIFICATION_ELEMENT":
          "components.popinDeleteElement.objectification",
        "DEL-THEME": "components.popinDeleteElement.theme",
        "DEL-SUBTHEME": "components.popinDeleteElement.subTheme"
      };

      var prefix = i18nPrefixes[this.params.type];

      this.title = this.$i18n.t(prefix + ".title", this.params);
      this.message = this.$i18n.t(prefix + ".message", this.params);
      this.sendButton = this.$i18n.t(prefix + ".sendBtn", this.params);
      this.cancelButton = this.$i18n.t(prefix + ".cancelBtn", this.params);
      this.message = this.$i18n.t(prefix + ".message", this.params);
    }
  },
  data: function() {
    return {
      title: "?",
      message: "",
      cancelButton: "Annuler",
      sendButton: "Valider"
    };
  },
  methods: {
    processAction: function() {
      var data = {};
      switch (this.params.type) {
        case "DEL-SUBTHEME":
          data = {
            type: this.params.type,
            params: {
              themeAbbr: this.params.themeAbbr,
              subThemeRef: this.params.subThemeRef
            }
          };
          this.$store.dispatch("editThemeElement", data);
          break;

        case "DEL-DESCRIPTION_SITUATION_ELEMENT":
          data = {
            type: this.params.type,
            params: {
              themeAbbr: this.params.themeAbbr,
              subThemeRef: this.params.subThemeRef,
              descriptionRef: this.params.descriptionRef
            }
          };
          this.$store.dispatch("editThemeElement", data);
          break;

        case "DEL-OBJECTIFICATION_ELEMENT":
          data = {
            type: this.params.type,
            params: {
              themeAbbr: this.params.themeAbbr,
              objectificationRef: this.params.objectificationRef
            }
          };
          this.$store.dispatch("editThemeElement", data);
          break;

        case "DEL-THEME":
          data = {
            type: this.params.type,
            params: {
              themeAbbr: this.params.themeAbbr
            }
          };
          this.$store.dispatch("deleteTheme", data);
          this.$emit("themeDeleted");
          break;
      }

      // Masquage de la popin
      this.$bvModal.hide("deleteElement");
    }
  }
};
</script>


<style lang="sass" scoped>
.message
  min-height: 1em
  margin: 1em 0 0 0
</style>
